import { Issue } from 'generated/types';
export var IssueEnum = {
    enumValues: [
        {
            name: Issue.MemberTermed,
            description: 'Member termed'
        },
        // request from Rishi to hide it for now NEX-25356
        // {
        //   name: Issue.NewMemberToBeAdded,
        //   description: 'New member to be added'
        // },
        {
            name: Issue.UpdatePersonCode,
            description: 'Update person code'
        },
        {
            name: Issue.UpdateGroupNumber,
            description: 'Update group number'
        },
        {
            name: Issue.UpdateDob,
            description: 'Update DOB'
        },
        {
            name: Issue.UpdateAddress,
            description: 'Update address'
        },
        {
            name: Issue.DuplicateProfiles,
            description: 'Duplicate profiles'
        },
        {
            name: Issue.CobQuestion,
            description: 'COB question'
        }
    ]
};
